/* Isoville live configurator — extracted from web/index.html (root engine unchanged) and
   adapted for embedding on the Shopify product page. Reads the address from the existing
   properties[Address] field and reacts to the existing properties[Style]/properties[View]
   selects, so no duplicate inputs and no extra cart-property wiring needed.
   Renderer math/drawing (iso projection, palettes, OSM element handling) is verbatim from the
   live site — do not change the projection, see CLAUDE.md rule 2. */
window.IsoConfigurator = (function () {
  "use strict";
  var PALETTES = {
    terra: { paper:'#F6F0E4', road:'#E3DAC8', roadLine:'#D6CBB4', park:'#DCE5CE', water:'#BFD9DA', rail:'#B9AE9C',
      canopy:'#8FB477', canopyDark:'#71975C', trunk:'#8A6B4F',
      walls:['#E8B48F','#DCA47E','#D9BC9A','#C98A6B','#E3C6A8'], wallShade:0.78,
      roof:['#F2DFC8','#EFD9BE','#F5E6D2'], accent:'#C0442E', ink:'#3A2E26', coord:'#8a8478' },
    mint: { paper:'#F1F4F0', road:'#E0E5E0', roadLine:'#D2D9D2', park:'#D5E4D2', water:'#B9D4D6', rail:'#A9BDB6',
      canopy:'#7BAA8C', canopyDark:'#5F8F72', trunk:'#7E6E5C',
      walls:['#9CC5BC','#8AB8AE','#B8D2CB','#7FAEA3','#AACBC2'], wallShade:0.76,
      roof:['#E6EEEA','#DDE8E3','#EDF3F0'], accent:'#0E6E62', ink:'#22332F', coord:'#7d8a80' },
    noir: { paper:'#23262B', road:'#2E3238', roadLine:'#383D44', park:'#2A3230', water:'#31414A', rail:'#4A525C',
      canopy:'#3E5A46', canopyDark:'#324A3A', trunk:'#584C40',
      walls:['#4A5058','#555C66','#3F454C','#5F6771','#494F58'], wallShade:0.7,
      roof:['#666E79','#707885','#5C636E'], accent:'#E8B44A', ink:'#E8ECEA', coord:'#7a828c' },
    /* Style palettes (22.09.): the live preview renders each AI style in its own palette so the choice is visible before ordering.
       The print itself is still crafted by the AI pipeline after the order; these are the vector base looks. */
    winter: { paper:'#EEF3F8', road:'#DDE4EC', roadLine:'#CDD6E0', park:'#E4ECF1', water:'#B7CFDD', rail:'#9AA7B3',
      canopy:'#C6D8CF', canopyDark:'#9DB5A9', trunk:'#6E5A4A',
      walls:['#D9C7B5','#CDB7A3','#E2D3C2','#C4AE9A','#D6C2AD'], wallShade:0.8,
      roof:['#FFFFFF','#F7FAFC','#F1F5F9'], accent:'#C0442E', ink:'#2F3A45', coord:'#7d8794' },
    neon: { paper:'#121828', road:'#1D2540', roadLine:'#4FC3E8', park:'#182231', water:'#14213A', rail:'#3C4560',
      canopy:'#26403C', canopyDark:'#1C302E', trunk:'#4A4458',
      walls:['#2E3552','#353D5C','#283048','#3B4467','#303857'], wallShade:0.72,
      roof:['#4A5478','#525C84','#43506F'], accent:'#FF3B6B', ink:'#EAF2FF', coord:'#8A97B8' },
    vangogh: { paper:'#EAD9B6', road:'#D8C398', roadLine:'#C4AA7C', park:'#9DB868', water:'#5B8DBF', rail:'#8C7A5E',
      canopy:'#7DA657', canopyDark:'#5D8747', trunk:'#6B4E36',
      walls:['#E2B96A','#D9A75A','#E8C98A','#C99A55','#DDB575'], wallShade:0.78,
      roof:['#4F6C9E','#5A78A8','#48619A'], accent:'#C8322B', ink:'#2B2A3A', coord:'#7a6f5a' },
    lineart: { paper:'#FFFFFF', road:'#F3F3F3', roadLine:'#B5B5B5', park:'#EFEFEF', water:'#E6E9EC', rail:'#9A9A9A',
      canopy:'#E3E3E3', canopyDark:'#C9C9C9', trunk:'#5E5E5E',
      walls:['#F6F6F6','#EFEFEF','#F9F9F9','#EAEAEA','#F2F2F2'], wallShade:0.88,
      roof:['#FCFCFC','#F7F7F7','#FDFDFD'], accent:'#C0442E', ink:'#2A2A2A', coord:'#8a8a8a', outline:'#3A3A3A', mono:true }
  };
  var M = 111320;
  /* AI art styles preview on the closest base palette; the print itself is crafted in the chosen style after ordering */
  var STYLE_MAP = { 'Mint Studio': 'mint', 'Terracotta': 'terra', 'Noir': 'noir',
    'Winter Wonderland': 'winter', 'Neon Nights': 'neon', 'Van Gogh': 'vangogh', 'Line Art': 'lineart' };
  var AI_STYLES = { 'Winter Wonderland': 1, 'Neon Nights': 1, 'Van Gogh': 1, 'Line Art': 1 };

  var STR = {
    en: { btn:'See preview', btnBusy:'Building …', lookup:'Looking up your address …',
      building:'Building your neighbourhood — houses, trees, bridges … (10–30 s)',
      done:'Your neighbourhood, ready. Try the styles and view direction above.',
      needAddr:'Enter your address above first.',
      noAddr:'Address not found — try "street + number, city" or add the postal code.',
      busyOverpass:'The preview could not be loaded right now. Please try again in a moment — your order does not depend on it.',
      noBuildings:"We can't find buildings here — does the address sit out in the green?",
      genericErr:'Something went wrong — please try again.',
      aiStart:'Your neighbourhood is set. Painting it in the {style} style now …',
      aiQueue:'Waiting for the painter …',
      aiSteps:['Placing streets and buildings …','Mixing the colours …','Brushstrokes …','Finishing touches …'],
      aiDone:'This is how your print will look.',
      aiFail:'The painted preview could not be created right now. The map above is correct — your print is painted in this style after you order.',
      aiLimit:'Preview limit reached for this visit. Your print is painted in the chosen style after you order.',
      aiStyle:'<strong>Preview only.</strong> This shows the layout of your neighbourhood, not the finished look. Your print is painted in the {style} style from exactly this map and will look like the {style} example in the gallery.' },
    de: { btn:'Vorschau ansehen', btnBusy:'Wird gebaut …', lookup:'Adresse wird gesucht …',
      building:'Dein Viertel entsteht — Häuser, Bäume, Brücken … (10–30 Sek.)',
      done:'Dein Viertel ist fertig. Probiere Stil und Blickrichtung oben aus.',
      needAddr:'Bitte zuerst oben deine Adresse eingeben.',
      noAddr:'Adresse nicht gefunden — versuch „Straße + Hausnummer, Ort" oder ergänze die Postleitzahl.',
      busyOverpass:'Die Vorschau konnte gerade nicht geladen werden. Bitte versuch es gleich noch einmal — deine Bestellung hängt nicht davon ab.',
      noBuildings:'Hier lassen sich keine Gebäude finden — liegt die Adresse im Grünen?',
      genericErr:'Etwas ist schiefgelaufen — bitte erneut versuchen.',
      aiStart:'Dein Viertel steht. Wir malen es jetzt im Stil {style} …',
      aiQueue:'Wartet auf den Maler …',
      aiSteps:['Straßen und Gebäude werden gesetzt …','Farben werden gemischt …','Pinselstriche …','Feinschliff …'],
      aiDone:'So wird dein Print aussehen.',
      aiFail:'Die gemalte Vorschau konnte gerade nicht erzeugt werden. Die Karte oben stimmt — dein Print wird nach der Bestellung in diesem Stil gemalt.',
      aiLimit:'Vorschau-Limit für diesen Besuch erreicht. Dein Print wird nach der Bestellung im gewählten Stil gemalt.',
      aiStyle:'<strong>Nur Vorschau.</strong> Das zeigt die Lage deines Viertels, nicht das fertige Aussehen. Dein Print wird aus genau dieser Karte im Stil {style} gefertigt und sieht aus wie das {style}-Beispiel in der Galerie.' }
  };

  function iso(x, y, z) { return { sx: (x - y) * 0.866, sy: (x + y) * 0.5 - z }; }
  function shade(hex, f) {
    var n = parseInt(hex.slice(1), 16), r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    return 'rgb(' + Math.round(r * f) + ',' + Math.round(g * f) + ',' + Math.round(b * f) + ')';
  }
  function hash(b) { var s = 0; for (var i = 0; i < b.pts.length; i++) { s += b.pts[i].x * 7.13 + b.pts[i].y * 3.7; } return Math.abs(Math.round(s)); }

  function init(opts) {
    var lang = (opts.de ? STR.de : STR.en);
    var API = 'https://isoville.pages.dev/api';  // edge proxy with mirror failover + cache (functions/api in the repo)
    function fetchJson(url, ms) {
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms) : null;
      return fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (j) { if (timer) clearTimeout(timer); return j; }, function (e) { if (timer) clearTimeout(timer); throw e; });
    }
    // ---- Fast path: z15 vector tiles (OpenStreetMap via Protomaps build) fetched from the edge and decoded here in the browser.
    // Produces the same {elements:[...]} structure as an Overpass answer, so everything below stays untouched.
    function fetchBytes(url, ms) {
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms) : null;
      return fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) {
        if (timer) clearTimeout(timer);
        if (r.status === 204) return new Uint8Array(0);
        if (!r.ok) throw new Error('http ' + r.status);
        return r.arrayBuffer().then(function (b) {
          var u = new Uint8Array(b);
          if (u.length > 2 && u[0] === 0x1f && u[1] === 0x8b) {  // gzip inside PMTiles: inflate here (DecompressionStream, all current browsers)
            if (typeof DecompressionStream === 'undefined') throw new Error('no DecompressionStream');
            return new Response(new Blob([u]).stream().pipeThrough(new DecompressionStream('gzip'))).arrayBuffer().then(function (d) { return new Uint8Array(d); });
          }
          return u;
        });
      }, function (e) { if (timer) clearTimeout(timer); throw e; });
    }
    function mvtVarint(buf, pos) { var result = 0, shift = 0, byte; do { byte = buf[pos++]; result += (byte & 0x7f) * Math.pow(2, shift); shift += 7; } while (byte >= 0x80); return [result, pos]; }
    function mvtFields(buf, start, end, cb) {
      var pos = start, r;
      while (pos < end) {
        r = mvtVarint(buf, pos); var tag = r[0]; pos = r[1];
        var field = tag >> 3, wt = tag & 7;
        if (wt === 0) { r = mvtVarint(buf, pos); pos = r[1]; cb(field, wt, r[0]); }
        else if (wt === 2) { r = mvtVarint(buf, pos); pos = r[1]; cb(field, wt, [pos, pos + r[0]]); pos += r[0]; }
        else if (wt === 5) { cb(field, wt, [pos, pos + 4]); pos += 4; }
        else if (wt === 1) { cb(field, wt, [pos, pos + 8]); pos += 8; }
        else throw new Error('bad wire type');
      }
    }
    var mvtText = new TextDecoder();
    function mvtValue(buf, s0, e0) {
      var out = null;
      mvtFields(buf, s0, e0, function (f, wt, v) {
        if (f === 1) out = mvtText.decode(buf.subarray(v[0], v[1]));
        else if (f === 2) out = new DataView(buf.buffer, buf.byteOffset + v[0], 4).getFloat32(0, true);
        else if (f === 3) out = new DataView(buf.buffer, buf.byteOffset + v[0], 8).getFloat64(0, true);
        else if (f === 4 || f === 5) out = v;
        else if (f === 6) out = (v % 2 === 1) ? -(v + 1) / 2 : v / 2;
        else if (f === 7) out = v !== 0;
      });
      return out;
    }
    function mvtPacked(buf, s0, e0) { var out = [], pos = s0, r; while (pos < e0) { r = mvtVarint(buf, pos); out.push(r[0]); pos = r[1]; } return out; }
    function mvtZigzag(v) { return (v % 2 === 1) ? -(v + 1) / 2 : v / 2; }
    function mvtDecode(buf) {
      var layers = [];
      mvtFields(buf, 0, buf.length, function (f, wt, v) {
        if (f !== 3) return;
        var layer = { name: '', extent: 4096, keys: [], values: [], features: [] }, featureRanges = [];
        mvtFields(buf, v[0], v[1], function (lf, lwt, lv) {
          if (lf === 1) layer.name = mvtText.decode(buf.subarray(lv[0], lv[1]));
          else if (lf === 2) featureRanges.push(lv);
          else if (lf === 3) layer.keys.push(mvtText.decode(buf.subarray(lv[0], lv[1])));
          else if (lf === 4) layer.values.push(mvtValue(buf, lv[0], lv[1]));
          else if (lf === 5) layer.extent = lv;
        });
        featureRanges.forEach(function (fr) {
          var feat = { id: 0, type: 0, props: {}, geom: [] }, tags = [], cmds = [];
          mvtFields(buf, fr[0], fr[1], function (ff, fwt, fv) {
            if (ff === 1) feat.id = fv; else if (ff === 3) feat.type = fv;
            else if (ff === 2) tags = fwt === 2 ? mvtPacked(buf, fv[0], fv[1]) : tags.concat([fv]);
            else if (ff === 4) cmds = fwt === 2 ? mvtPacked(buf, fv[0], fv[1]) : cmds.concat([fv]);
          });
          for (var i = 0; i + 1 < tags.length; i += 2) feat.props[layer.keys[tags[i]]] = layer.values[tags[i + 1]];
          var x = 0, y = 0, k = 0, cur = null;
          while (k < cmds.length) {
            var cmd = cmds[k++], id = cmd & 7, count = cmd >> 3;
            if (id === 1) { for (var c = 0; c < count; c++) { x += mvtZigzag(cmds[k++]); y += mvtZigzag(cmds[k++]); cur = [[x, y]]; feat.geom.push(cur); } }
            else if (id === 2) { for (var c2 = 0; c2 < count; c2++) { x += mvtZigzag(cmds[k++]); y += mvtZigzag(cmds[k++]); cur.push([x, y]); } }
            else if (id === 7) { if (cur && cur.length) cur.push(cur[0]); }
          }
          layer.features.push(feat);
        });
        layers.push(layer);
      });
      return layers;
    }
    var TL_HIGHWAYS = { primary: 1, secondary: 1, tertiary: 1, residential: 1, living_street: 1, pedestrian: 1, service: 1, footway: 1, path: 1, cycleway: 1 };
    var TL_RAILS = { rail: 1, subway: 1, light_rail: 1, tram: 1 }, TL_LEISURE = { park: 1, playground: 1, garden: 1, pitch: 1 };
    var TL_LANDUSE = { grass: 1, meadow: 1, allotments: 1, cemetery: 1, village_green: 1, recreation_ground: 1, forest: 1 };
    var TL_EDU = { school: 1, kindergarten: 1, university: 1, college: 1 }, TL_WATER = { water: 1, lake: 1, ocean: 1, sea: 1, reservoir: 1, basin: 1, swimming_pool: 1, pond: 1 };
    var TL_POI = { tree: { natural: 'tree' }, fountain: { amenity: 'fountain' }, street_lamp: { highway: 'street_lamp' }, bench: { amenity: 'bench' }, post_box: { amenity: 'post_box' }, bus_stop: { highway: 'bus_stop' },
      cafe: { amenity: 'cafe' }, bar: { amenity: 'bar' }, pub: { amenity: 'pub' }, restaurant: { amenity: 'restaurant' }, memorial: { historic: 'memorial' }, monument: { historic: 'monument' }, statue: { historic: 'statue' },
      museum: { tourism: 'museum' }, gallery: { tourism: 'gallery' }, attraction: { tourism: 'attraction' }, advertising_column: { advertising: 'column' } };
    function tileTags(layerName, p) {
      var kind = p.kind || '';
      if (layerName === 'buildings') { if (kind !== 'building') return null; var t = { building: 'yes' }; if (p.height) t.height = String(p.height); return t; }
      if (layerName === 'roads') { var kd = p.kind_detail || '', tr; if (kind === 'rail') { if (!TL_RAILS[kd]) return null; tr = { railway: kd }; } else { if (!TL_HIGHWAYS[kd]) return null; tr = { highway: kd }; } if (p.is_bridge || p.level > 0) tr.bridge = 'yes'; if (p.is_tunnel || p.level < 0) tr.tunnel = 'yes'; return tr; }
      if (layerName === 'landuse') { if (kind === 'railway') return { landuse: 'railway' }; if (TL_LEISURE[kind]) return { leisure: kind }; if (TL_LANDUSE[kind]) return { landuse: kind }; if (TL_EDU[kind]) return { amenity: kind }; return null; }
      if (layerName === 'water') { if (kind === 'canal' || kind === 'river') return { waterway: kind }; if (kind === 'fountain') return { amenity: 'fountain' }; if (TL_WATER[kind]) return { natural: 'water' }; return null; }
      if (layerName === 'pois') return TL_POI[kind] || null;
      return null;
    }
    function ringArea(r) { var a = 0; for (var i = 0; i + 1 < r.length; i++) a += r[i][0] * r[i + 1][1] - r[i + 1][0] * r[i][1]; return a / 2; }
    async function fetchTilesScene(lat, lon) {
      var Z = 15, R = 300, n = Math.pow(2, Z);
      var dlat = R / 111320, dlon = R / (111320 * Math.cos(lat * Math.PI / 180));
      var tx = function (lo) { return Math.floor((lo + 180) / 360 * n); };
      var ty = function (la) { return Math.floor((1 - Math.log(Math.tan(la * Math.PI / 180) + 1 / Math.cos(la * Math.PI / 180)) / Math.PI) / 2 * n); };
      var x0 = tx(lon - dlon), x1 = tx(lon + dlon), y0 = ty(lat + dlat), y1 = ty(lat - dlat), tiles = [];
      for (var x = x0; x <= x1; x++) for (var y = y0; y <= y1; y++) tiles.push([x, y]);
      var bufs = await Promise.all(tiles.map(function (t) { return fetchBytes(API + '/tile?z=' + Z + '&x=' + t[0] + '&y=' + t[1], 12000); }));
      var elements = [];
      var inBox = function (la, lo, f) { return Math.abs(la - lat) <= dlat * f && Math.abs(lo - lon) <= dlon * f; };
      tiles.forEach(function (t, ti) {
        var buf = bufs[ti]; if (!buf || !buf.length) return;
        var tx0 = t[0], ty0 = t[1];
        mvtDecode(buf).forEach(function (layer) {
          var ext = layer.extent;
          var toLL = function (px, py) { return [Math.atan(Math.sinh(Math.PI * (1 - 2 * (ty0 + py / ext) / n))) * 180 / Math.PI, (tx0 + px / ext) / n * 360 - 180]; };
          layer.features.forEach(function (f) {
            var tags = tileTags(layer.name, f.props); if (!tags) return;
            if (f.type === 1) {
              f.geom.forEach(function (pt) { var ll = toLL(pt[0][0], pt[0][1]); if (inBox(ll[0], ll[1], 1)) elements.push({ type: 'node', id: f.id, lat: ll[0], lon: ll[1], tags: tags }); });
            } else if (f.type === 2) {
              f.geom.forEach(function (line) { var ll = line.map(function (q) { return toLL(q[0], q[1]); }); if (!ll.some(function (q) { return inBox(q[0], q[1], 1.1); })) return;
                elements.push({ type: 'way', id: f.id, tags: tags, geometry: ll.map(function (q) { return { lat: q[0], lon: q[1] }; }) }); });
            } else if (f.type === 3) {
              f.geom.forEach(function (ring) {
                if (ring.length < 4 || ringArea(ring) <= 0) return;
                if (layer.name === 'water' && tags.amenity === 'fountain') { var cx = 0, cy = 0; ring.forEach(function (q) { cx += q[0]; cy += q[1]; }); var c0 = toLL(cx / ring.length, cy / ring.length); if (inBox(c0[0], c0[1], 1)) elements.push({ type: 'node', lat: c0[0], lon: c0[1], tags: tags }); return; }
                var ll = ring.map(function (q) { return toLL(q[0], q[1]); }); if (!ll.some(function (q) { return inBox(q[0], q[1], 1.1); })) return;
                elements.push({ type: 'way', id: f.id, tags: tags, geometry: ll.map(function (q) { return { lat: q[0], lon: q[1] }; }) });
              });
            }
          });
        });
      });
      return { elements: elements, source: 'tiles-client' };
    }
    var busy = false, SCENE = null, FLIP = false, CURPAL = 'terra', creepTimer = null;
    // Prefetch while the customer is still typing: geocode + tile scene are plain cacheable GETs, so the later click reuses the browser cache.
    var prefetchTimer = null, prefetchedFor = '';
    function prefetch() {
      var q = (addressInput.value || '').trim();
      if (q.length < 8 || q === prefetchedFor || busy) return;
      prefetchedFor = q;
      fetchJson(API + '/geocode?lang=en&q=' + encodeURIComponent(q), 12000).then(function (pj) {
        if (pj && pj.feature && pj.feature.geometry) { var c = pj.feature.geometry.coordinates; return fetchTilesScene(c[1], c[0]); }
      }).catch(function () {});
    }
    var addressInput = opts.addressInput,
        cv = opts.canvas, btn = opts.button, st = opts.statusEl, loadWrap = opts.progressWrap, bar = opts.progressBar,
        placeholder = opts.placeholder, spinner = opts.spinner, stage = opts.stage || (cv && cv.parentNode);
    // Style/View are read by form-field name, so a <select> or a radio-button group (style tiles) both work.
    // Fallback to the explicit opts.styleSelect / opts.viewSelect (print bridge render-order.html passes unnamed selects).
    function propEls(name) {
      var els = Array.prototype.slice.call(document.getElementsByName(name));
      if (!els.length) { var o = name === 'properties[Style]' ? opts.styleSelect : name === 'properties[View]' ? opts.viewSelect : null; if (o) els = [o]; }
      return els;
    }
    function propValue(name) {
      var els = propEls(name);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.tagName === 'SELECT') return el.value;
        if (el.type === 'radio') { if (el.checked) return el.value; }
        else if (el.value) return el.value;
      }
      return null;
    }
    addressInput.addEventListener('input', function () { clearTimeout(prefetchTimer); prefetchTimer = setTimeout(prefetch, 700); });
    addressInput.addEventListener('change', function () { clearTimeout(prefetchTimer); prefetch(); });

    function setProg(p) {
      if (!loadWrap) return;
      loadWrap.style.display = 'block'; bar.style.width = p + '%'; floatProg(p);
      if (p >= 100) { setTimeout(function () { loadWrap.style.display = 'none'; bar.style.width = '0%'; }, 700); }
    }
    function hideProg() { if (!loadWrap) return; loadWrap.style.display = 'none'; bar.style.width = '0%'; }
    function startCreep(from, to) {
      var p = from;
      stopCreep();
      creepTimer = setInterval(function () { p = Math.min(to, p + 1); setProg(p); }, 500);
    }
    function stopCreep() { if (creepTimer) { clearInterval(creepTimer); creepTimer = null; } }

    function mapStyle() { return STYLE_MAP[propValue('properties[Style]')] || 'terra'; }
    function isAiStyle() { return !!AI_STYLES[propValue('properties[Style]')]; }
    function aiMsg() { var n = propValue('properties[Style]'); return isAiStyle() ? lang.aiStyle.replace(/\{style\}/g, n) : lang.done; }

    /* ---------------- Echte KI-Vorschau (R+V 23.09., Modell 24.09.: Nano Banana Pro via /api/style-preview) ----------------
       Ablauf: Stufe 1 = Vektor-Render (sofort). Danach wird dieselbe Szene unsichtbar als KI-Basis gezeichnet (window.ISO_BASE:
       organischer Rand, kein Pin/Caption/Schatten), auf die Szene beschnitten (4:5, 14 % Papier) und an die Pages Function
       geschickt; das fertige Bild wird über das Canvas geblendet, die Adress-Caption kommt als HTML-Ebene darüber (V 24.09.:
       klein, dezent, Website-Typo, nicht von der KI). Ergebnis je Adresse+Stil+Ansicht wird client- und edge-seitig gecacht. */
    var aiSeq = 0, aiCache = {}, aiCount = 0, AI_MAX = 8, aiImg = null, aiCap = null;
    /* Schwebende Statusleiste (V 26.09.): oben fixiert, damit man auch ohne Scrollen sieht, dass gerade gerendert/gemalt wird. */
    var floatEl = null, floatTimer = null;
    function floatGet() {
      if (floatEl || !stage) return floatEl;
      floatEl = document.createElement('div'); floatEl.className = 'iso-cfg__float'; floatEl.hidden = true;
      floatEl.innerHTML = '<div class="iso-cfg__float-bar"></div><span class="iso-cfg__float-dot"></span><span class="iso-cfg__float-text"></span>';
      floatEl.addEventListener('click', function () { try { stage.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {} });
      var anc = opts.floatAnchor;
      if (anc && anc.parentNode) { floatEl.classList.add('iso-cfg__float--inline'); anc.parentNode.insertBefore(floatEl, anc.nextSibling); }
      else document.body.appendChild(floatEl);
      return floatEl;
    }
    function floatShow(msg) { var f = floatGet(); if (!f) return; clearTimeout(floatTimer); f.hidden = false; f.classList.remove('is-done'); if (msg) f.querySelector('.iso-cfg__float-text').textContent = msg; }
    function floatProg(p) { var f = floatGet(); if (f && !f.hidden) f.querySelector('.iso-cfg__float-bar').style.width = p + '%'; galProg(p); }
    function floatHide(ms, done) { var f = floatGet(); if (!f) return; if (done) f.classList.add('is-done'); clearTimeout(floatTimer); floatTimer = setTimeout(function () { f.hidden = true; f.querySelector('.iso-cfg__float-bar').style.width = '0%'; }, ms || 0); }
    function setStatus(msg) { if (st) { st.style.display = 'block'; st.textContent = msg; } var f = floatGet(); if (f && !f.hidden) f.querySelector('.iso-cfg__float-text').textContent = msg; galText(msg); }
    /* Galerie-Wartezustand (V 03.11.): solange die Vorschau entsteht, zeigt die Produktgalerie kein Beispielmotiv, sondern
       Status + Ladebalken. Ist das gemalte Bild fertig, verschwindet die Ebene und die Seite gleitet hoch zur Galerie.
       Balken: Karten-Phase 0–25 %, Mal-Phase 25–95 %, fertig 100 %. Ohne Produktgalerie (Print-Bridge) passiert nichts. */
    var galWait = null, galPhase = 'map', galScrollPending = false;
    function galHost() {
      var cs = document.querySelectorAll('media-gallery slideshow-container');
      for (var i = 0; i < cs.length; i++) if (!cs[i].closest('dialog')) return cs[i];
      return null;
    }
    function galWaitShow(phase) {
      var h = galHost(); if (!h) return;
      if (!galWait) {
        galWait = document.createElement('div'); galWait.className = 'iso-gal-wait';
        galWait.innerHTML = '<div class="iso-gal-wait__box"><span class="iso-gal-wait__dot"></span><div class="iso-gal-wait__text"></div><div class="iso-gal-wait__track"><div class="iso-gal-wait__bar"></div></div></div>';
      }
      if (galWait.parentNode !== h) h.appendChild(galWait);
      if (phase === 'map' || !galWait.classList.contains('is-on')) galWait.querySelector('.iso-gal-wait__bar').style.width = phase === 'map' ? '4%' : '25%';
      galPhase = phase; galWait.classList.remove('is-out'); galWait.classList.add('is-on');
    }
    function galText(msg) { if (galWait && galWait.classList.contains('is-on') && msg) galWait.querySelector('.iso-gal-wait__text').textContent = msg; }
    function galProg(p) {
      if (!galWait || !galWait.classList.contains('is-on') || galWait.classList.contains('is-out')) return;
      var g = galPhase === 'map' ? Math.min(25, p * 0.25) : Math.min(95, 25 + Math.max(0, p - 30) / 62 * 70);
      galWait.querySelector('.iso-gal-wait__bar').style.width = g + '%';
    }
    function galWaitHide(done) {
      if (!galWait || !galWait.classList.contains('is-on')) return;
      var w = galWait; if (done) w.querySelector('.iso-gal-wait__bar').style.width = '100%';
      w.classList.add('is-out');
      setTimeout(function () { if (w.classList.contains('is-out')) { w.classList.remove('is-on', 'is-out'); if (w.parentNode) w.parentNode.removeChild(w); } }, done ? 650 : 250);
    }
    function galScrollUp() {
      galScrollPending = false;
      var g = galHost(); if (!g) return;
      var r = g.getBoundingClientRect(), hd = document.querySelector('header-component, #header-component, .header'), off = 0;
      if (hd) { var hr = hd.getBoundingClientRect(); if (hr.bottom > 0 && hr.bottom < 160) off = hr.bottom; }
      if (r.top >= off - 2 && r.top < window.innerHeight * 0.35) return; /* Galerie steht schon oben im Bild */
      try { window.scrollTo({ top: Math.max(0, window.pageYOffset + r.top - off - 8), behavior: 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(0, window.pageYOffset + r.top - off - 8)); }
    }
    function aiEls() {
      if (!stage) return false;
      if (!aiImg) { aiImg = document.createElement('img'); aiImg.className = 'iso-cfg__ai'; aiImg.alt = ''; aiImg.hidden = true; stage.appendChild(aiImg); }
      if (!aiCap) { aiCap = document.createElement('div'); aiCap.className = 'iso-cfg__cap'; aiCap.hidden = true;
        aiCap.innerHTML = '<div class="iso-cfg__cap-name"></div><div class="iso-cfg__cap-sub"></div><div class="iso-cfg__cap-coord"></div>'; stage.appendChild(aiCap); }
      return true;
    }
    function hideAi() { aiSeq++; if (aiImg) aiImg.hidden = true; if (aiCap) aiCap.hidden = true; }
    function renderCaption() {
      if (!aiCap || !SCENE) return;
      var P = PALETTES[CURPAL] || PALETTES.terra;
      aiCap.children[0].textContent = SCENE.t1 || ''; aiCap.children[0].style.color = P.ink;
      aiCap.children[1].textContent = SCENE.t2 || ''; aiCap.children[1].style.color = P.coord;
      aiCap.children[2].textContent = SCENE.LAT0.toFixed(4) + '° N  /  ' + SCENE.LON0.toFixed(4) + '° E' + (FLIP ? '  ·  SOUTH VIEW' : ''); aiCap.children[2].style.color = P.coord;
      aiCap.hidden = false;
    }
    function cropToDataUrl(c, paperHex) {
      var W = c.width, H = c.height, d = c.getContext('2d').getImageData(0, 0, W, H).data;
      var pr = parseInt(paperHex.slice(1), 16), pR = (pr >> 16) & 255, pG = (pr >> 8) & 255, pB = pr & 255;
      var x0 = W, y0 = H, x1 = 0, y1 = 0;
      for (var y = 0; y < H; y += 2) for (var x = 0; x < W; x += 2) { var i = (y * W + x) * 4;
        if (Math.abs(d[i] - pR) + Math.abs(d[i + 1] - pG) + Math.abs(d[i + 2] - pB) > 30) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
      if (x1 <= x0) return c.toDataURL('image/jpeg', 0.9);
      var mx = (x1 - x0) * 0.22, my = (y1 - y0) * 0.22; // 22 % Papier: mit 14 % zoomte das Modell gelegentlich bis an den Rand (Winter, 24.09.)
      x0 = Math.max(0, x0 - mx); x1 = Math.min(W, x1 + mx); y0 = Math.max(0, y0 - my); y1 = Math.min(H, y1 + my);
      var cw = x1 - x0, ch = y1 - y0, tw, th;
      if (ch < cw * 1.25) { tw = cw; th = cw * 1.25; } else { th = ch; tw = ch / 1.25; }
      var o = document.createElement('canvas'); o.width = Math.round(tw); o.height = Math.round(th);
      var oc = o.getContext('2d'); oc.fillStyle = paperHex; oc.fillRect(0, 0, o.width, o.height);
      oc.drawImage(c, x0, y0, cw, ch, Math.round((tw - cw) / 2), Math.round((th - ch) / 2), cw, ch);
      return o.toDataURL('image/jpeg', 0.9);
    }
    function renderBaseDataUrl() {
      var off = document.createElement('canvas'); off.width = 1280; off.height = 1600;
      var saved = cv; cv = off; window.ISO_BASE = true; window.ISO_SILENT = true;
      try { drawScene(CURPAL); } finally { window.ISO_BASE = false; window.ISO_SILENT = false; cv = saved; }
      return cropToDataUrl(off, (PALETTES[CURPAL] || PALETTES.terra).paper);
    }
    /* Maskenprüfung (V 26.09.): manche Ergebnisse haben keine runde Maske, die Stadt berührt den Rand oder füllt das Bild.
       Bild per CORS (fal.media erlaubt es) klein ins Canvas, Papierfarbe des Stils als Referenz: Randring muss Papier sein,
       Szene höchstens ~90 % der Breite/Höhe — sonst bis zu 2 Neuversuche mit anderem Seed (Server umgeht dann den Cache). */
    /* Ergebnis auch gross in der Produktgalerie zeigen (V 01.10.): das Stil-Beispielbild (Alt "<Stil> – example …") wird durch
       das gemalte Bild der Kundenadresse ersetzt, Caption per Canvas eingebrannt (fal.media erlaubt CORS). Neue Adresse →
       Originale zurück. Rahmen-Shots bleiben die Beispiele. */
    var galOrig = [];
    function galleryRestore() {
      galOrig.forEach(function (o) { if (o.srcset) o.el.setAttribute('srcset', o.srcset); if (o.sizes) o.el.setAttribute('sizes', o.sizes); o.el.src = o.src; });
      galOrig = [];
    }
    function galleryShow(url, styleName) {
      if (!SCENE) return;
      var P = PALETTES[CURPAL] || PALETTES.terra, sc = SCENE, flip = FLIP;
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        var out = url;
        try {
          var c = document.createElement('canvas'), W = c.width = im.naturalWidth, H = c.height = im.naturalHeight, x = c.getContext('2d');
          x.drawImage(im, 0, 0); x.textAlign = 'center';
          x.fillStyle = P.ink; x.font = '500 ' + Math.round(W * 0.024) + 'px "Inter Tight", Inter, system-ui, sans-serif'; x.fillText(sc.t1 || '', W / 2, H * 0.925);
          x.fillStyle = P.coord; x.font = Math.round(W * 0.0145) + 'px "IBM Plex Mono", ui-monospace, Menlo, monospace';
          try { x.letterSpacing = Math.round(W * 0.002) + 'px'; } catch (e) {}
          if (sc.t2) x.fillText(sc.t2, W / 2, H * 0.947);
          x.fillText(sc.LAT0.toFixed(4) + '° N  /  ' + sc.LON0.toFixed(4) + '° E' + (flip ? '  ·  SOUTH VIEW' : ''), W / 2, H * 0.966);
          out = c.toDataURL('image/jpeg', 0.92);
        } catch (e) {}
        var prefix = styleName + ' – example', els = document.querySelectorAll('slideshow-slide img[alt], slideshow-controls img[alt]');
        for (var i = 0; i < els.length; i++) {
          var el = els[i]; if (el.closest('dialog') || (el.getAttribute('alt') || '').indexOf(prefix) !== 0) continue;
          var known = false; for (var k = 0; k < galOrig.length; k++) if (galOrig[k].el === el) known = true;
          if (!known) galOrig.push({ el: el, src: el.currentSrc || el.src, srcset: el.getAttribute('srcset'), sizes: el.getAttribute('sizes') });
          el.removeAttribute('srcset'); el.removeAttribute('sizes'); el.src = out;
        }
        showStyleSample(styleName, false, true);
        galWaitHide(true);
        if (galScrollPending) setTimeout(galScrollUp, 120);
      };
      im.onerror = function () { galWaitHide(); galScrollPending = false; };
      im.src = url;
    }
    function maskOk(im) {
      var W = 160, H = 200, c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.drawImage(im, 0, 0, W, H); var d = x.getImageData(0, 0, W, H).data;
      var pr = parseInt((PALETTES[CURPAL] || PALETTES.terra).paper.slice(1), 16), pR = (pr >> 16) & 255, pG = (pr >> 8) & 255, pB = pr & 255;
      var ring = 0, ringBad = 0, x0 = W, x1 = 0, y0 = H, y1 = 0;
      for (var yy = 0; yy < H; yy++) for (var xx = 0; xx < W; xx++) {
        var i = (yy * W + xx) * 4, p = (Math.abs(d[i] - pR) + Math.abs(d[i + 1] - pG) + Math.abs(d[i + 2] - pB)) < 120;
        if (xx < 5 || xx >= W - 5 || yy < 5 || yy >= H - 5) { ring++; if (!p) ringBad++; }
        if (!p) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
      }
      return ringBad / ring < 0.03 && (x1 - x0) < 0.9 * W && (y1 - y0) < 0.9 * H;
    }
    function aiPreview(attempt) {
      attempt = attempt || 0;
      if (!SCENE || !isAiStyle() || !aiEls()) { hideAi(); galWaitHide(); return; }
      var styleName = propValue('properties[Style]'), view = wantsSouth() ? 'South view' : 'North view';
      var address = (addressInput.value || '').trim(), key = [address.toLowerCase(), styleName, view].join('|');
      var seq = ++aiSeq;
      if (aiImg) aiImg.hidden = true; if (aiCap) aiCap.hidden = true;
      if (aiCache[key]) { showAi(aiCache[key]); return; }
      if (aiCount >= AI_MAX) { galWaitHide(); setStatus(lang.aiLimit); return; }
      galWaitShow('paint'); galScrollPending = true;
      floatShow(); setStatus(lang.aiStart.replace(/\{style\}/g, styleName)); startCreep(30, 92);
      var dataUrl; try { dataUrl = renderBaseDataUrl(); } catch (e) { try { console.error('iso ai base', e); } catch (x) {} stopCreep(); hideProg(); setStatus(lang.aiFail); galWaitHide(); galScrollPending = false; return; }
      aiCount++;
      var t0 = Date.now();
      function fail(e) { if (seq !== aiSeq) return; try { console.error('iso ai', e); } catch (x) {} stopCreep(); hideProg(); setStatus(lang.aiFail); floatHide(4000); galWaitHide(); galScrollPending = false; }
      function accept(url) {
        aiCache[key] = url; galleryShow(url, styleName);
        aiImg.onload = function () { aiImg.hidden = false; renderCaption(); stopCreep(); setProg(100); setStatus(lang.aiDone); floatHide(3000, true); };
        aiImg.onerror = fail; aiImg.src = url;
      }
      function showAi(url) {
        if (seq !== aiSeq && aiCache[key] !== url) return;
        if (aiCache[key] === url) return accept(url);
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () {
          if (seq !== aiSeq) return;
          var ok = true; try { ok = maskOk(im); } catch (e) { ok = true; }
          if (ok || attempt >= 2) return accept(url);
          try { console.warn('iso ai mask retry', attempt + 1); } catch (x) {}
          aiPreview(attempt + 1);
        };
        im.onerror = function () { accept(url); };
        im.src = url;
      }
      function poll(id, k, su, ru) {
        if (seq !== aiSeq) return;
        if (Date.now() - t0 > 150000) return fail('timeout');
        fetch(API + '/style-preview?id=' + encodeURIComponent(id) + '&key=' + encodeURIComponent(k) + (su ? '&su=' + encodeURIComponent(su) : '') + (ru ? '&ru=' + encodeURIComponent(ru) : '')).then(function (r) { return r.json(); }).then(function (j) {
          if (seq !== aiSeq) return;
          if (j.status === 'COMPLETED') return showAi(j.image);
          if (j.status === 'FAILED') return fail(j);
          if (j.status === 'IN_QUEUE') setStatus(lang.aiQueue);
          else setStatus(lang.aiSteps[Math.floor((Date.now() - t0) / 7000) % lang.aiSteps.length]);
          setTimeout(function () { poll(id, k, su, ru); }, 2500);
        }).catch(fail);
      }
      fetch(API + '/style-preview', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image: dataUrl, style: styleName, view: view, address: address, seed: 7 + attempt, retry: attempt > 0, facts: window.__ISO_FACTS || null }) })
        .then(function (r) { return r.json(); }).then(function (j) {
          if (seq !== aiSeq) return;
          if (j.status === 'COMPLETED') return showAi(j.image);
          if (j.status !== 'IN_QUEUE') return fail(j);
          setStatus(lang.aiQueue); setTimeout(function () { poll(j.id, j.key, j.su, j.ru); }, 2500);
        }).catch(fail);
    }
    /* Gallery follows style + finish: media alts are "<Style> – example …" (full scene) and "<Style> – <Finish>" (frame shots).
       Style click with finish "Unframed" shows the example; any finish change shows the style in that frame. */
    function currentFinish() { var el = document.querySelector('input[name^="Finish-"]:checked'); return el ? el.value : 'Unframed'; }
    function desiredImg(name, preferFrame, forceExample) {
      if (!name) return null;
      var finish = currentFinish(), want = name + ' \u2013 ' + finish;
      var imgs = document.querySelectorAll('slideshow-slide img[alt]'), exact = null, example = null;
      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i]; if (im.closest('dialog, slideshow-controls')) continue; /* main slides only, not thumbnails or the zoom dialog */
        var alt = im.getAttribute('alt');
        if (!exact && alt === want) exact = im; else if (!example && alt.indexOf(name + ' \u2013 example') === 0) example = im;
      }
      if (forceExample) return example || exact;
      return (preferFrame || finish !== 'Unframed') ? (exact || example) : (example || exact);
    }
    function activeImg() {
      var slides = document.querySelectorAll('slideshow-slide');
      for (var i = 0; i < slides.length; i++) { var s = slides[i]; if (s.getAttribute('aria-hidden') === 'false' && !s.closest('dialog, slideshow-controls') && s.querySelector('img')) return s.querySelector('img'); }
      return null;
    }
    function showStyleSample(name, preferFrame, forceExample) {
      var img = desiredImg(name, preferFrame, forceExample); if (!img) return;
      var slide = img.closest('slideshow-slide'), comp = slide && slide.closest('slideshow-component');
      if (!comp || typeof comp.select !== 'function') return;
      var id = slide.getAttribute('slide-id');
      try { comp.select(id ? { id: id } : Array.prototype.indexOf.call(comp.querySelectorAll('slideshow-slide'), slide), undefined, { animate: false }); } catch (e) {}
      /* select() is a no-op on a gallery Horizon has just swapped in (internal state not ready); a plain instant scroll always
         works and Horizon's own scroll handler then syncs current slide, aria-hidden and thumbnails from the position. */
      var sc = comp.querySelector('[ref="scroller"]') || comp.querySelector('slideshow-slides');
      if (sc) {
        var left = slide.getBoundingClientRect().left - sc.getBoundingClientRect().left + sc.scrollLeft;
        if (Math.abs(sc.scrollLeft - left) > 1) { try { sc.scrollTo({ left: left, top: sc.scrollTop, behavior: 'instant' }); } catch (e) { sc.scrollLeft = left; } }
      }
    }
    /* Variant change: Horizon fetches the section and would REPLACE <media-gallery> with the fetched copy, which then starts
       at slide 0 (flash) and behaves erratically afterwards. No variant carries its own media, so the gallery never needs
       replacing: in the capture phase (our promise callback runs before the gallery's) we drop <media-gallery> from the
       fetched document, keep the existing gallery and just select the slide for style + finish. */
    var lastFinish = currentFinish();
    document.addEventListener('shopify:product:select', function (ev) {
      if (!ev.promise || !ev.target || !ev.target.closest || !ev.target.closest('variant-picker')) return;
      var style = propValue('properties[Style]');
      ev.promise.then(function (res) {
        var html = res && res.detail && res.detail.html; if (!html) return;
        var mg = html.querySelector('media-gallery'); if (mg && document.querySelector('media-gallery')) mg.parentNode.removeChild(mg);
        if (!style) return;
        var finish = null, opts = res.variant && res.variant.selectedOptions;
        if (opts && opts.length) { for (var o = 0; o < opts.length; o++) { if (opts[o].name === 'Finish') finish = opts[o].value; } }
        if (!finish) { var inp = html.querySelector('input[name^="Finish-"][checked]'); finish = inp ? inp.value : currentFinish(); }
        var preferFrame = finish !== lastFinish || finish !== 'Unframed'; lastFinish = finish;
        showStyleSample(style, preferFrame);
        setTimeout(function () { showStyleSample(style, preferFrame); }, 400);
      }).catch(function () {});
    }, true);
    function wantsSouth() { return propValue('properties[View]') === 'South view'; }

    async function startPreview() {
      if (busy) return;
      var q = (addressInput.value || '').trim();
      if (!q) { addressInput.focus(); if (st) { st.style.display = 'block'; st.textContent = lang.needAddr; } return; }
      busy = true;
      btn.disabled = true; btn.textContent = lang.btnBusy;
      if (placeholder) placeholder.hidden = true;
      if (spinner) spinner.hidden = false;
      hideAi(); galleryRestore(); floatShow(lang.lookup); galWaitShow('map'); galText(lang.lookup); galScrollPending = true;
      if (st) { st.style.display = 'block'; st.textContent = lang.lookup; }
      setProg(8);
      try {
        var f = null;
        try { var pj = await fetchJson(API + '/geocode?lang=en&q=' + encodeURIComponent(q), 15000); if (pj && pj.feature) f = pj.feature; } catch (e) {}
        if (!f) try {
          var g = await fetchJson('https://photon.komoot.io/api/?limit=5&lang=en&q=' + encodeURIComponent(q), 12000);
          if (g.features && g.features.length) {
            var pref = ['house', 'building', 'street'];
            f = g.features.find(function (x) { return x.properties && pref.indexOf(x.properties.type) !== -1; }) || g.features[0];
          }
        } catch (e) {}
        if (!f) {
          try {
            var n = await fetchJson('https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&addressdetails=1&q=' + encodeURIComponent(q), 12000);
            if (n && n.length) {
              var r = n[0], a = r.address || {};
              f = { geometry: { coordinates: [parseFloat(r.lon), parseFloat(r.lat)] },
                properties: { street: a.road || '', housenumber: a.house_number || '', city: a.city || a.town || a.village || '', district: a.suburb || '', name: r.name || '' } };
            }
          } catch (e) {}
        }
        if (!f) throw new Error(lang.noAddr);
        var LON0 = f.geometry.coordinates[0], LAT0 = f.geometry.coordinates[1];
        var pr = f.properties || {};
        var t1 = ((pr.street || pr.name || 'YOUR BLOCK') + (pr.housenumber && pr.street ? ' ' + pr.housenumber : '')).toUpperCase();
        var t2 = ((pr.city || pr.county || '') + (pr.district ? ' · ' + pr.district : '')).toUpperCase();
        setProg(30);
        if (st) st.textContent = lang.building;
        var CLAT = Math.cos(LAT0 * Math.PI / 180);
        var oq = '[out:json][timeout:25];(way(around:300,' + LAT0 + ',' + LON0 + ')[building];way(around:300,' + LAT0 + ',' + LON0 + ')[highway~"^(primary|secondary|tertiary|residential|living_street|pedestrian|service)$"];way(around:300,' + LAT0 + ',' + LON0 + ')[highway~"^(footway|path|cycleway)$"];way(around:300,' + LAT0 + ',' + LON0 + ')[leisure~"^(park|playground|garden|pitch)$"];way(around:300,' + LAT0 + ',' + LON0 + ')[landuse~"^(grass|meadow|allotments|cemetery|village_green|recreation_ground|forest)$"];way(around:300,' + LAT0 + ',' + LON0 + ')[amenity~"^(school|kindergarten|university|college)$"];way(around:300,' + LAT0 + ',' + LON0 + ')[natural=water];way(around:400,' + LAT0 + ',' + LON0 + ')[natural=coastline];way(around:300,' + LAT0 + ',' + LON0 + ')[waterway~"^(canal|river)$"];way(around:300,' + LAT0 + ',' + LON0 + ')[railway~"^(subway|rail|light_rail|tram)$"];node(around:300,' + LAT0 + ',' + LON0 + ')[natural=tree];node(around:300,' + LAT0 + ',' + LON0 + ')[amenity=fountain];node(around:300,' + LAT0 + ',' + LON0 + ')[historic~"^(memorial|monument)$"];node(around:300,' + LAT0 + ',' + LON0 + ')[highway=street_lamp];node(around:300,' + LAT0 + ',' + LON0 + ')[amenity~"^(bench|post_box)$"];node(around:300,' + LAT0 + ',' + LON0 + ')[advertising=column];node(around:300,' + LAT0 + ',' + LON0 + ')[highway=bus_stop];node(around:300,' + LAT0 + ',' + LON0 + ')[amenity~"^(cafe|bar|pub|restaurant)$"];node(around:300,' + LAT0 + ',' + LON0 + ')[tourism~"^(museum|gallery|attraction)$"];way(around:300,' + LAT0 + ',' + LON0 + ')[tourism~"^(museum|gallery)$"];node(around:300,' + LAT0 + ',' + LON0 + ')[historic=statue];);out geom;';
        setProg(48);
        startCreep(48, 70);
        var data = null;
        var oqParam = '?data=' + encodeURIComponent(oq);
        // 0) vector tiles decoded in the browser (fastest, no Worker CPU limit)  1) tile scene built at the edge  2) Overpass via edge proxy  3) public mirrors directly
        try { var tj = await fetchTilesScene(LAT0, LON0); if (tj && tj.elements && tj.elements.some(function (e) { return e.tags && e.tags.building; })) data = tj; } catch (e) {}
        var endpoints = [[API + '/scene?lat=' + LAT0 + '&lon=' + LON0, 12000], [API + '/osm' + oqParam, 55000], ['https://overpass-api.de/api/interpreter' + oqParam, 28000], ['https://overpass.kumi.systems/api/interpreter' + oqParam, 28000], ['https://overpass.private.coffee/api/interpreter' + oqParam, 28000]];
        for (var round = 0; round < 2 && !(data && data.elements); round++) {
          if (round) { if (st) st.textContent = lang.building; await new Promise(function (res) { setTimeout(res, 2500); }); }
          for (var i = 0; i < endpoints.length; i++) {
            try { var j = await fetchJson(endpoints[i][0], endpoints[i][1]); if (j && j.elements && j.elements.length) { data = j; break; } } catch (e) {}
          }
        }
        stopCreep();
        if (!data || !data.elements) throw new Error(lang.busyOverpass);
        setProg(75);
        var loc = function (lat, lon) { return { x: (lat - LAT0) * M, y: (lon - LON0) * M * CLAT }; };
        var buildings = [], roads = [], parks = [], waters = [], canals = [], rails = [], trees = [], paths = [], plays = [], spots = [], pitches = [], greens = [], edus = [];
        for (var ei = 0; ei < data.elements.length; ei++) {
          var el = data.elements[ei], t = el.tags || {};
          if (el.type === 'node') {
            if (el.lat === undefined) continue;
            var p = loc(el.lat, el.lon);
            if (t.natural === 'tree') trees.push({ kind: 't', x: p.x, y: p.y, depth: p.x + p.y, r: Math.hypot(p.x, p.y), tt: Math.abs(Math.round(p.x * 13.7 + p.y * 7.9)) % 10 });
            else if (t.amenity === 'fountain') spots.push({ kind: 's', st: 'fountain', x: p.x, y: p.y, depth: p.x + p.y, r: Math.hypot(p.x, p.y) });
            else if (t.historic) spots.push({ kind: 's', st: 'mon', x: p.x, y: p.y, depth: p.x + p.y, r: Math.hypot(p.x, p.y) });
            else {
              var mt = t.highway === 'street_lamp' ? 'lamp' : t.amenity === 'bench' ? 'bench' : t.amenity === 'post_box' ? 'post' : t.advertising === 'column' ? 'litfass' : t.highway === 'bus_stop' ? 'bus' : /^(cafe|bar|pub|restaurant)$/.test(t.amenity || '') ? 'gastro' : /^(museum|gallery|attraction)$/.test(t.tourism || '') ? 'mus' : t.historic === 'statue' ? 'mon' : null;
              if (mt) spots.push({ kind: 's', st: mt, x: p.x, y: p.y, depth: p.x + p.y, r: Math.hypot(p.x, p.y) });
            }
            continue;
          }
          if (!el.geometry) continue;
          var pts = el.geometry.map(function (g2) { return loc(g2.lat, g2.lon); });
          var isBridge = t.bridge && t.bridge !== 'no';
          if (t.building) {
            if (pts.length < 4) continue;
            var h = 12;
            if (t.height) { var p2 = parseFloat(t.height); if (!isNaN(p2)) h = p2; }
            else if (t['building:levels']) { var l = parseFloat(t['building:levels']); if (!isNaN(l)) h = l * 3.1 + 1.5; }
            h = Math.min(h, 55);
            var cx = pts.reduce(function (s, p3) { return s + p3.x; }, 0) / pts.length, cy = pts.reduce(function (s, p3) { return s + p3.y; }, 0) / pts.length;
            var ar = 0; for (var pi = 0; pi < pts.length - 1; pi++) { ar += pts[pi].x * pts[pi + 1].y - pts[pi + 1].x * pts[pi].y; } ar = Math.abs(ar / 2);
            var rs = t['roof:shape'], hb = Math.abs(Math.round(cx * 7.13 + cy * 3.7));
            var isFlat = rs ? (rs === 'flat') : (ar > 1800 || h >= 26 || hb % 10 < 7);
            var isChurch = t.building === 'church' || t.building === 'cathedral' || t.building === 'chapel' || t.amenity === 'place_of_worship';
            var isDome = rs === 'dome' || rs === 'onion';
            var bc = null, bcRaw = t['building:colour']; if (bcRaw && /^#[0-9a-fA-F]{6}$/.test(bcRaw)) bc = bcRaw;
            buildings.push({ kind: 'b', pts: pts, h: h, cx: cx, cy: cy, flat: isFlat && !isChurch && !isDome, church: isChurch, dome: isDome, bc: bc, depth: Math.max.apply(null, pts.map(function (p3) { return p3.x + p3.y; })), r: Math.hypot(cx, cy) });
          } else if (/^(footway|path|cycleway)$/.test(t.highway || '')) { paths.push({ pts: pts }); }
          else if (t.highway) { if (!(t.tunnel && t.tunnel !== 'no')) roads.push({ pts: pts, major: /primary|secondary/.test(t.highway), bridge: isBridge }); } // Straßentunnel nicht zeichnen
          else if (t.natural === 'coastline') {
            if (pts.length >= 2) {
              var a0 = pts[0], a1 = pts[pts.length - 1];
              var dx = a1.x - a0.x, dy = a1.y - a0.y, L = Math.hypot(dx, dy) || 1;
              var rx = -dy / L * 600, ry = dx / L * 600;
              waters.push(pts.concat([{ x: a1.x + rx, y: a1.y + ry }, { x: a0.x + rx, y: a0.y + ry }]));
            }
          }
          else if (t.natural === 'water') { waters.push(pts); }
          else if (t.waterway) { canals.push(pts); }
          else if (t.railway) { if (!(t.tunnel && t.tunnel !== 'no')) rails.push({ pts: pts, bridge: isBridge }); } // Tunnel (U-Bahn unter der Erde) nicht zeichnen
          else if (t.leisure === 'playground') { plays.push(pts); }
          else if (t.leisure === 'pitch') { pitches.push(pts); }
          else if (t.leisure) { parks.push(pts); }
          else if (t.landuse === 'railway') { edus.push(pts); } /* Bahngelaende: graue Flaeche, nicht Gruen und nicht leer */
          else if (t.landuse) { greens.push(pts); }
          else if (t.tourism) { edus.push(pts); }
          else if (t.amenity) { edus.push(pts); }
        }
        (function () {
          var g2 = spots.filter(function (s2) { return s2.st === 'gastro'; }).sort(function (a2, b2) { return a2.r - b2.r; }).slice(0, 50);
          var rest = spots.filter(function (s2) { return s2.st !== 'gastro'; });
          spots.length = 0; Array.prototype.push.apply(spots, rest); Array.prototype.push.apply(spots, g2);
        })();
        if (!buildings.length) throw new Error(lang.noBuildings);
        var target = null, best = 1e9;
        for (var bi = 0; bi < buildings.length; bi++) { if (buildings[bi].r < best) { best = buildings[bi].r; target = buildings[bi]; } }
        SCENE = { buildings: buildings, roads: roads, parks: parks, waters: waters, canals: canals, rails: rails, trees: trees, paths: paths, plays: plays, spots: spots, pitches: pitches, greens: greens, edus: edus, target: target, t1: t1, t2: t2, LAT0: LAT0, LON0: LON0 };
        FLIP = false;
        setProg(92);
        cv.hidden = false;
        if (placeholder) placeholder.hidden = true;
        drawScene(mapStyle());
        if (wantsSouth()) applyFlip(true);
        setProg(100);
        if (st) st[isAiStyle() ? 'innerHTML' : 'textContent'] = aiMsg();
        if (isAiStyle()) aiPreview(); else { floatHide(2500, true); galWaitHide(); galScrollPending = false; }
      } catch (e) {
        stopCreep();
        hideProg();
        if (st) st.textContent = '⚠ ' + (e.message || lang.genericErr);
        floatShow('⚠ ' + (e.message || lang.genericErr)); floatHide(4000); galWaitHide(); galScrollPending = false;
      } finally {
        if (spinner) spinner.hidden = true;
        if (placeholder && cv.hidden) placeholder.hidden = false;
        setTimeout(function () { busy = false; btn.disabled = false; btn.textContent = lang.btn; }, 4000);
      }
    }

    function applyFlip(target) {
      if (!SCENE || FLIP === target) return;
      FLIP = !FLIP;
      var neg = function (p) { p.x = -p.x; p.y = -p.y; };
      [SCENE.waters, SCENE.canals, SCENE.parks, SCENE.plays || [], SCENE.pitches || [], SCENE.greens || [], SCENE.edus || []].forEach(function (arr) {
        arr.forEach(function (poly) { poly.forEach(neg); });
      });
      SCENE.roads.forEach(function (rd) { rd.pts.forEach(neg); });
      SCENE.rails.forEach(function (rl) { rl.pts.forEach(neg); });
      (SCENE.paths || []).forEach(function (pa) { pa.pts.forEach(neg); });
      SCENE.trees.forEach(function (t) { neg(t); t.depth = t.x + t.y; });
      (SCENE.spots || []).forEach(function (s) { neg(s); s.depth = s.x + s.y; });
      SCENE.buildings.forEach(function (b) { b.pts.forEach(neg); b.cx = -b.cx; b.cy = -b.cy; b.depth = Math.max.apply(null, b.pts.map(function (p) { return p.x + p.y; })); });
      drawScene(CURPAL);
    }

    function drawScene(pal) {
      if (!SCENE) return;
      CURPAL = pal;
      var P = PALETTES[pal];
      if (window.ISO_BASE && pal === 'neon') P = Object.assign({}, P, { roadLine: '#26304F' }); // KI-Basis: keine duennen Neonlinien (V 24.09.), Glow kommt vom Modell
      var buildings = SCENE.buildings, roads = SCENE.roads, parks = SCENE.parks, waters = SCENE.waters, canals = SCENE.canals, rails = SCENE.rails, trees = SCENE.trees, target = SCENE.target, t1 = SCENE.t1, t2 = SCENE.t2, LAT0 = SCENE.LAT0, LON0 = SCENE.LON0;
      var paths = SCENE.paths || [], plays = SCENE.plays || [], spots = SCENE.spots || [], pitches = SCENE.pitches || [], greens = SCENE.greens || [], edus = SCENE.edus || [];
      var ctx = cv.getContext('2d');
      cv.style.background = P.paper;
      var W = cv.width, H = cv.height;
      ctx.fillStyle = P.paper; ctx.fillRect(0, 0, W, H);
      // ISO_BASE: Massstab so, dass der organische Rand (max. 1,19 R, Iso-Breite 1,225 R) mit ~5 % Luft ins Bild passt
      // (1,225 * 300 * 1,19 * S <= 0,45 W); bei W = 1600 → S ≈ 1,65 statt 2,05 — sonst schneidet die Szene links/rechts.
      var S = window.ISO_BASE ? Math.min(2.05, 0.45 * W / (1.225 * 300 * 1.19)) : 2.05,
          OX = W / 2, OY = H / 2 - 60, R = 300, BR_H = 5.5, RH = 3.4, K = 0.55;
      var T = function (x, y, z) { var p2 = iso(x, y, z); return [OX + p2.sx * S, OY + p2.sy * S]; };
      var path = function (pts, z) { ctx.beginPath(); pts.forEach(function (p2, i) { var t3 = T(p2.x, p2.y, z || 0); i ? ctx.lineTo(t3[0], t3[1]) : ctx.moveTo(t3[0], t3[1]); }); };
      /* ISO_BASE (KI-Basis): organischer Szenenrand wie auf der Landing seit 22.09. (V-Entscheid) — Bodenlagen werden hart
         auf einen wobbelnden Kreis (R = 300 m, Phasen aus der Adresse) geclippt, Objekte folgen demselben Rand, außen Papier. */
      var ph1 = (LAT0 * 97.13) % (2 * Math.PI), ph2 = (LON0 * 57.29) % (2 * Math.PI), ph3 = ((LAT0 + LON0) * 31.7) % (2 * Math.PI);
      var rimR = function (x, y) { var ang = Math.atan2(y, x); return R * (1 + 0.09 * Math.sin(3 * ang + ph1) + 0.06 * Math.sin(7 * ang + ph2) + 0.04 * Math.sin(13 * ang + ph3)); };
      var inRim = function (o) { return window.ISO_BASE ? o.r <= rimR(o.kind === 'b' ? o.cx : o.x, o.kind === 'b' ? o.cy : o.y) : o.r <= R; };
      if (window.ISO_BASE) {
        ctx.save(); ctx.beginPath();
        for (var a2 = 0; a2 <= 96; a2++) { var ang2 = a2 / 96 * 2 * Math.PI, rr = rimR(Math.cos(ang2), Math.sin(ang2)); var t4 = T(Math.cos(ang2) * rr, Math.sin(ang2) * rr, 0); a2 ? ctx.lineTo(t4[0], t4[1]) : ctx.moveTo(t4[0], t4[1]); }
        ctx.closePath(); ctx.clip();
      }
      waters.forEach(function (w) { path(w); ctx.closePath(); ctx.fillStyle = P.water; ctx.fill(); });
      canals.forEach(function (cn) { path(cn); ctx.strokeStyle = P.water; ctx.lineWidth = 56; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.stroke(); });
      /* ISO_BASE (V 01.10.: „U-Bahn-Trassen werden als Fluss gemalt"): Zeichen eindeutig machen.
         Wasser = einzige Fläche mit Wellen-Marken (Stil-Bibel); Gleise = dunkles Band mit Schwellen (Karten-Signatur). */
      window.__ISO_FACTS = { water: (waters.length + canals.length) > 0, rail: rails.length > 0 };
      var trkCol = pal === 'neon' ? '#AEB8E0' : '#3A3A3A';
      var track = function (pts, z) {
        path(pts, z); ctx.strokeStyle = trkCol; ctx.lineWidth = 5; ctx.lineCap = 'butt'; ctx.lineJoin = 'round'; ctx.setLineDash([]); ctx.stroke();
        path(pts, z); ctx.lineWidth = 14; ctx.setLineDash([2.5, 7]); ctx.stroke(); ctx.setLineDash([]);
      };
      if (window.ISO_BASE) {
        ctx.strokeStyle = pal === 'neon' ? 'rgba(130,180,255,0.6)' : pal === 'lineart' ? 'rgba(80,80,80,0.65)' : 'rgba(255,255,255,0.65)'; ctx.lineWidth = 2; ctx.lineCap = 'round'; ctx.setLineDash([]);
        var wave = function (x0, y0) { ctx.beginPath(); ctx.moveTo(x0, y0); ctx.quadraticCurveTo(x0 + 6, y0 - 3.5, x0 + 12, y0); ctx.quadraticCurveTo(x0 + 18, y0 + 3.5, x0 + 24, y0); ctx.stroke(); };
        waters.forEach(function (w) { ctx.save(); path(w); ctx.closePath(); ctx.clip(); for (var yy = 0; yy < H; yy += 26) for (var xx = (yy / 26 % 2) * 18; xx < W; xx += 46) wave(xx, yy); ctx.restore(); });
        canals.forEach(function (cn) { for (var i = 0; i < cn.length - 1; i++) { var a = T(cn[i].x, cn[i].y, 0), b2 = T(cn[i + 1].x, cn[i + 1].y, 0), dx = b2[0] - a[0], dy = b2[1] - a[1], len = Math.hypot(dx, dy), steps = Math.max(1, Math.floor(len / 46));
          for (var s2 = 0; s2 < steps; s2++) { var fx = a[0] + dx * (s2 + 0.3) / steps, fy = a[1] + dy * (s2 + 0.3) / steps; wave(fx - 12, fy - 9); wave(fx, fy + 9); } } });
      }
      greens.forEach(function (gr) { path(gr); ctx.closePath(); ctx.fillStyle = shade(P.park, 1.08); ctx.fill(); });
      edus.forEach(function (ed) { path(ed); ctx.closePath(); ctx.fillStyle = shade(P.road, 1.1); ctx.globalAlpha = 0.55; ctx.fill(); ctx.globalAlpha = 1; });
      parks.forEach(function (pk) { path(pk); ctx.closePath(); ctx.fillStyle = P.park; ctx.fill(); });
      pitches.forEach(function (pt2) {
        path(pt2); ctx.closePath(); ctx.fillStyle = shade(P.park, 0.82); ctx.fill();
        ctx.strokeStyle = P.paper; ctx.lineWidth = 2; ctx.stroke();
        var mx = 0, my = 0, n2 = 0; pt2.forEach(function (p2) { mx += p2.x; my += p2.y; n2++; }); mx /= n2; my /= n2;
        var c1 = T(mx - 6, my + 6, 0), c2 = T(mx + 6, my - 6, 0);
        ctx.beginPath(); ctx.moveTo(c1[0], c1[1]); ctx.lineTo(c2[0], c2[1]); ctx.stroke();
      });
      plays.forEach(function (pg) { path(pg); ctx.closePath(); ctx.fillStyle = shade(P.paper, 0.93); ctx.fill(); ctx.strokeStyle = shade(P.park, 0.85); ctx.lineWidth = 1.5; ctx.setLineDash([6, 5]); ctx.stroke(); ctx.setLineDash([]); });
      paths.forEach(function (pa) { path(pa.pts); ctx.strokeStyle = shade(P.road, 1.06); ctx.lineWidth = 6; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.stroke(); });
      roads.forEach(function (rd) { if (rd.bridge) return; path(rd.pts); ctx.strokeStyle = P.road; ctx.lineWidth = rd.major ? 26 : 16; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.stroke(); ctx.strokeStyle = P.roadLine; ctx.lineWidth = 2; ctx.stroke(); });
      rails.forEach(function (rl) { if (rl.bridge) return; if (window.ISO_BASE) return track(rl.pts, 0); path(rl.pts); ctx.strokeStyle = P.rail; ctx.lineWidth = 9; ctx.setLineDash([20, 12]); ctx.stroke(); ctx.setLineDash([]); });
      rails.forEach(function (rl) {
        if (!rl.bridge) return;
        ctx.strokeStyle = shade(P.rail, 0.75); ctx.lineWidth = 5;
        for (var i = 0; i < rl.pts.length; i += 2) { var p2 = rl.pts[i]; var g2 = T(p2.x, p2.y, 0), d = T(p2.x, p2.y, BR_H); ctx.beginPath(); ctx.moveTo(g2[0], g2[1]); ctx.lineTo(d[0], d[1]); ctx.stroke(); }
        path(rl.pts, BR_H); ctx.strokeStyle = shade(P.rail, 0.85); ctx.lineWidth = 13; ctx.lineCap = 'round'; ctx.stroke();
        if (window.ISO_BASE) track(rl.pts, BR_H);
        else { path(rl.pts, BR_H); ctx.strokeStyle = P.paper; ctx.lineWidth = 3; ctx.setLineDash([14, 10]); ctx.stroke(); ctx.setLineDash([]); }
      });
      roads.forEach(function (rd) {
        if (!rd.bridge) return;
        ctx.strokeStyle = shade(P.road, 0.8); ctx.lineWidth = 4;
        for (var i = 0; i < rd.pts.length; i += 2) { var p2 = rd.pts[i]; var g2 = T(p2.x, p2.y, 0), d = T(p2.x, p2.y, BR_H); ctx.beginPath(); ctx.moveTo(g2[0], g2[1]); ctx.lineTo(d[0], d[1]); ctx.stroke(); }
        path(rd.pts, BR_H); ctx.strokeStyle = shade(P.road, 0.92); ctx.lineWidth = rd.major ? 24 : 15; ctx.lineCap = 'round'; ctx.stroke();
      });
      if (window.ISO_BASE) ctx.restore(); // Ende Rand-Clip — Gebäude behalten am Rand ihre vollen 3D-Körper
      var SHX = -1.25, SHY = 1.25;
      var sc2 = document.createElement('canvas'); sc2.width = W; sc2.height = H; var sx2 = sc2.getContext('2d'); sx2.fillStyle = '#000';
      buildings.forEach(function (b) {
        if (b.r > R) return; var n = b.pts.length;
        var spts = b.pts.map(function (p2) { return { x: p2.x + b.h * SHX, y: p2.y + b.h * SHY }; });
        for (var i = 0; i < n - 1; i++) {
          var q1 = T(b.pts[i].x, b.pts[i].y, 0), q2 = T(b.pts[i + 1].x, b.pts[i + 1].y, 0), q3 = T(spts[i + 1].x, spts[i + 1].y, 0), q4 = T(spts[i].x, spts[i].y, 0);
          sx2.beginPath(); sx2.moveTo(q1[0], q1[1]); sx2.lineTo(q2[0], q2[1]); sx2.lineTo(q3[0], q3[1]); sx2.lineTo(q4[0], q4[1]); sx2.closePath(); sx2.fill();
        }
        sx2.beginPath(); spts.forEach(function (p2, i) { var t3 = T(p2.x, p2.y, 0); i ? sx2.lineTo(t3[0], t3[1]) : sx2.moveTo(t3[0], t3[1]); }); sx2.closePath(); sx2.fill();
      });
      trees.forEach(function (o) { if (o.r > R) return; var t3 = T(o.x + 3.2 * SHX, o.y + 3.2 * SHY, 0); sx2.beginPath(); sx2.ellipse(t3[0], t3[1], 7, 4, 0, 0, 7); sx2.fill(); });
      if (!window.ISO_BASE) { ctx.globalAlpha = 0.22; ctx.drawImage(sc2, 0, 0); ctx.globalAlpha = 1; } // ISO_BASE: KI-Basis ohne Schlagschatten (Stil-Bibel)
      var objs = buildings.concat(trees, spots).sort(function (a, b) { return a.depth - b.depth; });
      objs.forEach(function (o) {
        if (!inRim(o)) return;
        if (o.kind === 's') {
          var g2 = T(o.x, o.y, 0);
          if (o.st === 'fountain') {
            ctx.beginPath(); ctx.arc(g2[0], g2[1], 5.5, 0, 7); ctx.fillStyle = P.water; ctx.fill();
            ctx.strokeStyle = shade(P.water, 0.8); ctx.lineWidth = 1.5; ctx.stroke();
            ctx.beginPath(); ctx.arc(g2[0], g2[1], 1.8, 0, 7); ctx.fillStyle = P.paper; ctx.fill();
          } else if (o.st === 'mon') {
            var tp = T(o.x, o.y, 6);
            ctx.strokeStyle = P.trunk; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(g2[0], g2[1]); ctx.lineTo(tp[0], tp[1]); ctx.stroke();
            ctx.beginPath(); ctx.arc(tp[0], tp[1], 2.2, 0, 7); ctx.fillStyle = P.trunk; ctx.fill();
          } else if (o.st === 'lamp') {
            var tp2 = T(o.x, o.y, 4.5);
            ctx.strokeStyle = shade(P.ink, 1.6); ctx.lineWidth = 1.2; ctx.beginPath(); ctx.moveTo(g2[0], g2[1]); ctx.lineTo(tp2[0], tp2[1]); ctx.stroke();
            ctx.beginPath(); ctx.arc(tp2[0], tp2[1], 1.6, 0, 7); ctx.fillStyle = '#E8C468'; ctx.fill();
          } else if (o.st === 'bench') {
            ctx.strokeStyle = P.trunk; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(g2[0] - 3, g2[1]); ctx.lineTo(g2[0] + 3, g2[1]); ctx.stroke();
          } else if (o.st === 'post') {
            ctx.fillStyle = '#D9A520'; ctx.fillRect(g2[0] - 1.5, g2[1] - 3, 3, 3);
          } else if (o.st === 'litfass') {
            var tp3 = T(o.x, o.y, 3.6);
            ctx.strokeStyle = shade(P.walls[0], 0.75); ctx.lineWidth = 3.5; ctx.beginPath(); ctx.moveTo(g2[0], g2[1]); ctx.lineTo(tp3[0], tp3[1]); ctx.stroke();
            ctx.beginPath(); ctx.arc(tp3[0], tp3[1], 2.4, 0, 7); ctx.fillStyle = shade(P.walls[0], 1.12); ctx.fill();
          } else if (o.st === 'bus') {
            var tp4 = T(o.x, o.y, 3.8);
            ctx.strokeStyle = shade(P.ink, 1.4); ctx.lineWidth = 1.2; ctx.beginPath(); ctx.moveTo(g2[0], g2[1]); ctx.lineTo(tp4[0], tp4[1]); ctx.stroke();
            ctx.fillStyle = P.accent; ctx.fillRect(tp4[0] - 2, tp4[1] - 2.5, 4, 2.5);
          } else if (o.st === 'gastro') {
            ctx.beginPath(); ctx.arc(g2[0], g2[1], 3.2, 0, 7); ctx.fillStyle = shade(P.trunk, 1.3); ctx.fill();
            ctx.strokeStyle = P.paper; ctx.lineWidth = 1; ctx.stroke();
            ctx.fillStyle = P.paper; ctx.fillRect(g2[0] - 2.4, g2[1] - 1.1, 4.8, 1.1);
          } else if (o.st === 'mus') {
            ctx.fillStyle = shade(P.ink, 1.25);
            ctx.fillRect(g2[0] - 4, g2[1] - 2.5, 8, 2.5);
            ctx.beginPath(); ctx.moveTo(g2[0] - 5, g2[1] - 2.5); ctx.lineTo(g2[0] + 5, g2[1] - 2.5); ctx.lineTo(g2[0], g2[1] - 7); ctx.closePath(); ctx.fill();
          }
          return;
        }
        if (o.kind === 't') {
          var tt = o.tt === undefined ? 0 : o.tt;
          var g3 = T(o.x, o.y, 0);
          if (tt >= 6 && tt <= 7) {
            var c = T(o.x, o.y, 2.2), m1 = T(o.x, o.y, 5.2), m2 = T(o.x, o.y, 8.2);
            ctx.strokeStyle = P.trunk; ctx.lineWidth = 2.5;
            ctx.beginPath(); ctx.moveTo(g3[0], g3[1]); ctx.lineTo(c[0], c[1]); ctx.stroke();
            ctx.beginPath(); ctx.moveTo(c[0] - 6, c[1]); ctx.lineTo(c[0] + 6, c[1]); ctx.lineTo(m1[0], m1[1]); ctx.closePath(); ctx.fillStyle = P.canopyDark; ctx.fill();
            ctx.beginPath(); ctx.moveTo(c[0] - 4.2, m1[1] + 3); ctx.lineTo(c[0] + 4.2, m1[1] + 3); ctx.lineTo(m2[0], m2[1]); ctx.closePath(); ctx.fillStyle = P.canopy; ctx.fill();
          } else if (tt === 8) {
            var c2 = T(o.x, o.y, 5.5);
            ctx.strokeStyle = P.trunk; ctx.lineWidth = 2.5;
            ctx.beginPath(); ctx.moveTo(g3[0], g3[1]); ctx.lineTo(c2[0], c2[1] + 6); ctx.stroke();
            ctx.beginPath(); ctx.ellipse(c2[0], c2[1], 3.6, 8.5, 0, 0, 7); ctx.fillStyle = P.canopyDark; ctx.fill();
            ctx.beginPath(); ctx.ellipse(c2[0] - 1, c2[1] - 1.5, 2.6, 6.5, 0, 0, 7); ctx.fillStyle = P.canopy; ctx.fill();
          } else if (tt === 9) {
            var c3 = T(o.x, o.y, 1.4);
            ctx.beginPath(); ctx.arc(c3[0], c3[1], 4.2, 0, 7); ctx.fillStyle = P.canopyDark; ctx.fill();
            ctx.beginPath(); ctx.arc(c3[0] - 1, c3[1] - 1, 3, 0, 7); ctx.fillStyle = P.canopy; ctx.fill();
          } else {
            var c4 = T(o.x, o.y, 4.2);
            ctx.strokeStyle = P.trunk; ctx.lineWidth = 2.5;
            ctx.beginPath(); ctx.moveTo(g3[0], g3[1]); ctx.lineTo(c4[0], c4[1]); ctx.stroke();
            ctx.beginPath(); ctx.arc(c4[0], c4[1], 6.5, 0, 7); ctx.fillStyle = P.canopyDark; ctx.fill();
            ctx.beginPath(); ctx.arc(c4[0] - 1.5, c4[1] - 1.8, 5, 0, 7); ctx.fillStyle = P.canopy; ctx.fill();
          }
          return;
        }
        var b = o, isT = (b === target), n2 = b.pts.length;
        var wall = isT ? P.accent : P.walls[hash(b) % P.walls.length];
        var roof = isT ? P.accent : P.roof[hash(b) % P.roof.length];
        if (b.bc && !isT && !P.mono) {
          var m = parseInt(b.bc.slice(1), 16), prc = parseInt(wall.slice(1), 16);
          var mix = function (a2, c2) { return Math.round(a2 * 0.55 + c2 * 0.45); };
          wall = '#' + [16, 8, 0].map(function (sh2) { return mix((m >> sh2) & 255, (prc >> sh2) & 255).toString(16).padStart(2, '0'); }).join('');
        }
        var sh = b.pts.map(function (p2) { return { x: b.cx + (p2.x - b.cx) * K, y: b.cy + (p2.y - b.cy) * K }; });
        for (var i = 0; i < n2 - 1; i++) {
          var a = b.pts[i], c5 = b.pts[i + 1];
          var nx = c5.y - a.y, ny = -(c5.x - a.x);
          var fShade = (nx - ny) > 0 ? 1.0 : P.wallShade;
          var p1 = T(a.x, a.y, 0), p2b = T(c5.x, c5.y, 0), p3 = T(c5.x, c5.y, b.h), p4 = T(a.x, a.y, b.h);
          ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2b[0], p2b[1]); ctx.lineTo(p3[0], p3[1]); ctx.lineTo(p4[0], p4[1]); ctx.closePath();
          ctx.fillStyle = fShade === 1.0 ? wall : shade(wall, fShade); ctx.fill();
          if (P.outline) { ctx.strokeStyle = P.outline; ctx.lineWidth = 0.9; ctx.lineJoin = 'round'; ctx.stroke(); }
        }
        if (b.flat) {
          path(b.pts, b.h); ctx.closePath(); ctx.fillStyle = shade(roof, isT ? 1.25 : 1.0); ctx.fill();
          ctx.strokeStyle = P.outline || shade(roof, 0.9); ctx.lineWidth = 1; ctx.stroke();
        } else {
          for (var i2 = 0; i2 < n2 - 1; i2++) {
            var a2 = b.pts[i2], c6 = b.pts[i2 + 1], sa = sh[i2], sc = sh[i2 + 1];
            var nx2 = c6.y - a2.y, ny2 = -(c6.x - a2.x);
            var fShade2 = (nx2 - ny2) > 0 ? 1.0 : 0.84;
            var q1 = T(a2.x, a2.y, b.h), q2 = T(c6.x, c6.y, b.h), q3 = T(sc.x, sc.y, b.h + RH), q4 = T(sa.x, sa.y, b.h + RH);
            ctx.beginPath(); ctx.moveTo(q1[0], q1[1]); ctx.lineTo(q2[0], q2[1]); ctx.lineTo(q3[0], q3[1]); ctx.lineTo(q4[0], q4[1]); ctx.closePath();
            ctx.fillStyle = shade(roof, fShade2 * 0.94); ctx.fill();
            if (P.outline) { ctx.strokeStyle = P.outline; ctx.lineWidth = 0.9; ctx.lineJoin = 'round'; ctx.stroke(); }
          }
          path(sh, b.h + RH); ctx.closePath(); ctx.fillStyle = shade(roof, isT ? 1.28 : 1.05); ctx.fill();
          ctx.strokeStyle = P.outline || shade(roof, 0.88); ctx.lineWidth = 1; ctx.stroke();
        }
        if (b.church) {
          var bt = T(b.cx, b.cy, b.h + RH), tpC = T(b.cx, b.cy, b.h + RH + 14), tip = T(b.cx, b.cy, b.h + RH + 22);
          ctx.strokeStyle = shade(roof, 0.8); ctx.lineWidth = 7;
          ctx.beginPath(); ctx.moveTo(bt[0], bt[1]); ctx.lineTo(tpC[0], tpC[1]); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(tpC[0] - 5, tpC[1]); ctx.lineTo(tpC[0] + 5, tpC[1]); ctx.lineTo(tip[0], tip[1]); ctx.closePath();
          ctx.fillStyle = shade(roof, 0.7); ctx.fill();
        } else if (b.dome) {
          var dc = T(b.cx, b.cy, b.h + RH + 3);
          ctx.beginPath(); ctx.arc(dc[0], dc[1], 9, 0, 7); ctx.fillStyle = shade(roof, 1.15); ctx.fill();
          ctx.strokeStyle = shade(roof, 0.85); ctx.lineWidth = 1.5; ctx.stroke();
        }
      });
      if (target && !window.ISO_BASE) { // ISO_BASE: Zielhaus nur rot, kein Drop-Pin
        var t3b = T(target.cx, target.cy, target.h + 26);
        ctx.beginPath(); ctx.arc(t3b[0], t3b[1], 14, 0, 7); ctx.fillStyle = P.accent; ctx.fill();
        ctx.beginPath(); ctx.moveTo(t3b[0] - 13, t3b[1] + 6); ctx.lineTo(t3b[0] + 13, t3b[1] + 6); ctx.lineTo(t3b[0], t3b[1] + 34); ctx.closePath(); ctx.fill();
        ctx.beginPath(); ctx.arc(t3b[0], t3b[1], 6, 0, 7); ctx.fillStyle = P.paper; ctx.fill();
      }
      if (!window.ISO_BASE) (function () { // Vignette nur im Shop-Preview; KI-Basis endet hart am organischen Rand
        var pr2 = parseInt(P.paper.slice(1), 16);
        var rgba2 = function (a2) { return 'rgba(' + ((pr2 >> 16) & 255) + ',' + ((pr2 >> 8) & 255) + ',' + (pr2 & 255) + ',' + a2 + ')'; };
        var fg = ctx.createRadialGradient(W / 2, H / 2 - 60, W * 0.40, W / 2, H / 2 - 60, W * 0.74);
        fg.addColorStop(0, rgba2(0)); fg.addColorStop(0.5, rgba2(0.4)); fg.addColorStop(0.85, rgba2(0.92)); fg.addColorStop(1, rgba2(1));
        ctx.fillStyle = fg; ctx.fillRect(0, 0, W, H);
      })();
      if (window.ISO_BASE) { // KI-Basis: keine Caption, kein Kompass (kommen später als Vektor-Ebene)
        if (!window.ISO_SILENT) { try { document.dispatchEvent(new CustomEvent('iso:rendered', { detail: { canvas: cv } })); } catch (e) {} }
        return;
      }
      ctx.fillStyle = P.ink; ctx.textAlign = 'center';
      ctx.font = '600 58px Georgia, serif';
      ctx.fillText(t1, W / 2, H - 190);
      if (t2) { ctx.font = '24px "Segoe UI", sans-serif'; ctx.letterSpacing = '9px'; ctx.fillText(t2, W / 2, H - 140); ctx.letterSpacing = '0px'; }
      ctx.font = '22px "Segoe UI", sans-serif'; ctx.fillStyle = P.coord;
      ctx.fillText(LAT0.toFixed(4) + '° N  /  ' + LON0.toFixed(4) + '° E' + (FLIP ? '  ·  SOUTH VIEW' : ''), W / 2, H - 100);
      var nd = FLIP ? [-0.866, -0.5] : [0.866, 0.5];
      var ccx = W - 150, ccy = H - 160, cr = 46;
      ctx.strokeStyle = P.coord; ctx.lineWidth = 3;
      ctx.beginPath(); ctx.arc(ccx, ccy, cr, 0, 7); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(ccx - nd[0] * cr * 0.6, ccy - nd[1] * cr * 0.6); ctx.lineTo(ccx + nd[0] * cr * 0.62, ccy + nd[1] * cr * 0.62); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(ccx + nd[0] * cr * 0.9, ccy + nd[1] * cr * 0.9);
      ctx.lineTo(ccx + nd[0] * cr * 0.45 - nd[1] * cr * 0.18, ccy + nd[1] * cr * 0.45 + nd[0] * cr * 0.18);
      ctx.lineTo(ccx + nd[0] * cr * 0.45 + nd[1] * cr * 0.18, ccy + nd[1] * cr * 0.45 - nd[0] * cr * 0.18);
      ctx.closePath(); ctx.fillStyle = P.accent; ctx.fill();
      ctx.font = '600 26px "Segoe UI", sans-serif'; ctx.fillStyle = P.ink; ctx.textAlign = 'center';
      ctx.fillText('N', ccx + nd[0] * (cr + 22), ccy + nd[1] * (cr + 22) + 9);
      try { document.dispatchEvent(new CustomEvent('iso:rendered', { detail: { canvas: cv } })); } catch (e) {}
    }

    btn.addEventListener('click', function (e) { e.preventDefault(); startPreview(); });
    addressInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); startPreview(); } });
    propEls('properties[Style]').forEach(function (el) { el.addEventListener('change', function () {
      showStyleSample(propValue('properties[Style]'));
      if (SCENE) { drawScene(mapStyle()); if (st) { st.style.display = 'block'; st[isAiStyle() ? 'innerHTML' : 'textContent'] = aiMsg(); } aiPreview(); }
    }); });
    propEls('properties[View]').forEach(function (el) { el.addEventListener('change', function () { if (SCENE) { applyFlip(wantsSouth()); aiPreview(); } }); });
  }

  return { init: init };
})();

/* ------------------------------------------------------------------------------------------------
 * Galerie-Übernahme: Nach jedem Live-Render (Event `iso:rendered` aus drawScene) werden alle
 * Produkt-/Galerie-Bilder, die eines der bekannten Mockups zeigen, client-seitig neu komponiert:
 * Original-Mockup + Besucher-Motiv in die Poster-Fläche. Die Rechtecke stammen deterministisch aus
 * pipeline/shopify/redesign/make_mockups.py bzw. make_assets.py (dort wurden die Bilder erzeugt).
 * Koordinaten beziehen sich auf 1600×2000; CDN-Größen werden über naturalWidth skaliert.
 * ---------------------------------------------------------------------------------------------- */
(function () {
  /* Off by default since 22.09. (styles are AI-crafted after order, the vector render would misrepresent the print in the mockups).
     Enable with window.ISO_GALLERY_TAKEOVER = true before this script loads. */
  if (!window.ISO_GALLERY_TAKEOVER) return;
  var MAP = [
    { m: 'frame-unframed-', r: [300, 335, 1000, 1250], glass: 0 },
    { m: 'frame-black-',    r: [300, 335, 1000, 1250], glass: 1 },
    { m: 'frame-white-',    r: [300, 335, 1000, 1250], glass: 1 },
    { m: 'frame-oak-',      r: [300, 335, 1000, 1250], glass: 1 },
    { m: 'mockup-living-',  r: [312, 302, 975, 1240],  glass: 1 },
    { m: 'mockup-gallery-', r: [299, 303, 1000, 1240], glass: 1 },
    { m: 'mockup-osteria-', r: [306, 299, 988, 1241],  glass: 1 },
    { m: 'fraenkelufer-mint-studio',  r: [0, 0, 1600, 2000], glass: 0 },
    { m: 'bergmannkiez-terracotta',   r: [0, 0, 1600, 2000], glass: 0 },
    { m: 'skalitzer-v2-noir',         r: [0, 0, 1600, 2000], glass: 0 }
  ];
  var baseCache = {}, composedCache = {}, renderSeq = 0;
  function confFor(src) {
    if (!src) return null;
    for (var i = 0; i < MAP.length; i++) { if (src.indexOf(MAP[i].m) >= 0) return MAP[i]; }
    return null;
  }
  function loadBase(url, cb) {
    if (baseCache[url] && baseCache[url].complete) return cb(baseCache[url]);
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () { cb(im); };
    im.onerror = function () {};
    baseCache[url] = im;
    im.src = url;
  }
  function compose(base, cv, c) {
    var W = base.naturalWidth, H = base.naturalHeight;
    var oc = document.createElement('canvas'); oc.width = W; oc.height = H;
    var x = oc.getContext('2d');
    x.drawImage(base, 0, 0);
    var sx = W / 1600, sy = H / 2000;
    var rx = c.r[0] * sx, ry = c.r[1] * sy, rw = c.r[2] * sx, rh = c.r[3] * sy;
    x.drawImage(cv, rx, ry, rw, rh);
    if (c.glass) { /* dezente Innenschatten-Kante wie im PIL-Original ("behind glass") */
      var alphas = [0.22, 0.14, 0.08, 0.04];
      x.strokeStyle = '#14161a'; x.lineWidth = Math.max(1, 1.6 * sx);
      for (var i = 0; i < alphas.length; i++) {
        x.globalAlpha = alphas[i];
        var o = (i + 0.5) * 1.6 * sx;
        x.strokeRect(rx + o, ry + o, rw - 2 * o, rh - 2 * o);
      }
      x.globalAlpha = 1;
    }
    try { return oc.toDataURL('image/jpeg', 0.88); } catch (e) { return null; }
  }
  function swapAll(cv) {
    var seq = ++renderSeq;
    composedCache = {};
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        var origin = img.getAttribute('data-iso-base') || img.currentSrc || img.src;
        var c = confFor(origin);
        if (!c) return;
        if (!img.getAttribute('data-iso-base')) img.setAttribute('data-iso-base', origin);
        loadBase(origin, function (base) {
          if (seq !== renderSeq) return; /* veralteter Render */
          var key = c.m + '|' + origin;
          var url = composedCache[key] || (composedCache[key] = compose(base, cv, c));
          if (!url) return;
          img.removeAttribute('srcset'); img.removeAttribute('sizes');
          img.src = url;
        });
      })(imgs[i]);
    }
  }
  document.addEventListener('iso:rendered', function (ev) {
    if (ev.detail && ev.detail.canvas) swapAll(ev.detail.canvas);
  });
})();
